import * as token from "./tokenUtil";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const requestMethod = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
}

export function asyncRequest(configs) {
    let options = {
        url: API_BASE_URL + configs.url,
        method: configs.method || requestMethod.POST,
    };

    let headers = new Headers();
    if (configs.header) {
        for (const [key, value] of Object.entries(configs.header)) {
            headers.append(key, value);
        }
    }

    const accessToken = token.getAccessToken();
    if (accessToken) {
        // headers.append("bz-token",  accessToken);
        headers.append("Authorization",  "Bearer " + accessToken);
    }

    if (! configs.isFile) {
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
    }

    options.headers = headers;

    if (! configs.isFile && configs.data) {
        options.body = JSON.stringify(configs.data);
    } else if (configs.isFile && configs.data) {
        options.body = configs.data;
    }

    // 로딩 처리
    const setLoading = configs.setLoading || ((param) => {});
    const loadingText = configs.loadingText || '';
    setLoading(true, loadingText);

    const success = configs.success || ((param) => {});

    return fetch(options.url, options)
        .then((res) => {
            if (res.status === 200) {
                res.json().then((json) => {
                    const code = json.code;
                    if (code !== "1000") {
                        alert(json.message)

                        if(configs.redirect_url != null) {
                            window.location.href = configs.redirect_url;
                        }
                    } else {
                        success(json.data);
                    }
                });
            } else if (res.status === 401) {
                alert('로그인 정보가 만료되었거나 로그아웃된 세션입니다. 다시 로그인해주세요.');
                signOut();
            } else if (res.status === 403) {
                alert("접근 권한이 없습니다.");
                signOut();
            }

            // 로딩 처리
            setLoading(false, '');
        })
        .catch((error) => {
            // const status = err.response.status;
            // const msg = err.response.data.message;
            //
            // if (status === 404 || status === 405) {
            //     alert("존재하지 않는 요청입니다.");
            // } else if (status === 403) {
            //     alert(msg);
            // } else if (status === 500) {
            //     alert("요청 작업을 처리하는 도중 오류가 발생하였습니다.");
            // } else {
            // }
            setLoading(false);
        });
}

export function fileDownloadRequest(configs) {
    let options = {
        url: API_BASE_URL + configs.url,
        method: configs.method || requestMethod.POST,
    };

    let headers = new Headers();
    if (configs.header) {
        for (const [key, value] of Object.entries(configs.header)) {
            headers.append(key, value);
        }
    }

    const accessToken = token.getAccessToken();
    if (accessToken) {
        // headers.append("bz-token",  accessToken);
        headers.append("Authorization",  "Bearer " + accessToken);
    }

    if (! configs.isFile) {
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
    }

    options.headers = headers;

    if (! configs.isFile && configs.data) {
        options.body = JSON.stringify(configs.data);
    } else if (configs.isFile && configs.data) {
        options.body = configs.data;
    }

    // 로딩 처리
    const setLoading = configs.setLoading || ((param) => {});
    setLoading(true);

    const success = configs.success || ((param) => {});

    return fetch(options.url, options)
        .then((res) => {
            if (res.status === 200) {
                const filename = res.headers.get('Content-Filename');
                res.blob().then((blob) => {
                    success(blob, filename);
                });
            } else if (res.status === 401) {
                alert('로그인 정보가 만료되었거나 로그아웃된 세션입니다. 다시 로그인해주세요.');
                signOut();
            } else if (res.status === 403) {
                alert("접근 권한이 없습니다.");
                signOut();
            }

            // 로딩 처리
            setLoading(false);
        })
        .catch((error) => {
            setLoading(false);
        });
}

export function signIn(user) {
    const alimtalkRef = window.sessionStorage.getItem('alimtalkRef');
    asyncRequest({
        // setLoading: setLoading,
        url: "/api/auth/signin",
        method: requestMethod.POST,
        data: {
            siteid: user.userid,
            password: user.password,
            alimtalkRef: alimtalkRef,
        },
        success: (result) => {
            if (result && result.accessToken) {

                window.sessionStorage.removeItem('alimtalkRef');

                /* 로그인 정보 저장 체크시 localStorage 저장 */
                if(user.remember) {
                    token.setAccessToken(result.accessToken);
                    token.setRefreshToken(result.refreshToken);
                } else {
                    token.setAccessTokenToSessionStorage(result.accessToken);
                    token.setRefreshTokenToSessionStorage(result.refreshToken);
                }

                // 유입 링크로 들어와 로그인이 필요한 목적지로 가려던 경우, 로그인 완료 후 그 페이지로 보낸다.
                let redirect = "/";
                try {
                    const pending = window.sessionStorage.getItem('postLoginRedirect');
                    if (pending) {
                        window.sessionStorage.removeItem('postLoginRedirect');
                        redirect = pending;
                    }
                } catch (e) {
                    // sessionStorage 접근 불가 시 기본 목적지(/)로 진행한다.
                }

                window.location.href = redirect;
            }
        }
    });
}

export function signOut() {
    const accessToken = token.getAccessToken();
    const logout = accessToken
        ? fetch(API_BASE_URL + "/api/auth/logout", {
            method: requestMethod.POST,
            headers: {
                "Authorization": "Bearer " + accessToken,
                "Content-Type": "application/json",
            },
        })
        : Promise.resolve();

    // 로그아웃 API 성공 여부와 관계없이 로컬 인증 정보는 제거한다.
    logout.catch(() => {}).finally(() => {
        token.clearToken();
        window.location.href = "/account/login";
    });
}

export function tokenReissueRequest(configs) {
    let options = {
        url: API_BASE_URL + '/api/auth/token/reissue',
        method: requestMethod.POST,
        headers: new Headers()
    };

    /* headers setting */
    const refreshToken = token.getRefreshToken();
    if (refreshToken) options.headers.append("Authorization",  "Bearer " + refreshToken);
    options.headers.append('Content-Type', 'application/json');
    options.headers.append('Accept', 'application/json');

    // 로딩 처리
    const setLoading = configs.setLoading || ((param) => {});
    setLoading(true);

    const success = configs.success || ((param) => {});

    return fetch(options.url, options)
        .then((res) => {
            if (res.status === 200) {
                res.json().then((json) => {
                    if (json.code !== "1000") alert(json.message)
                    else success(json.data);
                });
            } else if (res.status === 401) {
                /* refresh token 만료된 경우 로그아웃 처리 */
                alert('로그인 정보가 만료되었습니다. 다시 로그인해주세요.');
                signOut();
            } else if (res.status === 403) {
                signOut();
            }

            setLoading(false);
        })
        .catch((error) => {
            setLoading(false);
        });
}


export async function getClientIp() {
    const response = await fetch('https://api.ipify.org?format=json');
    const responseJson = await response.json();
    return responseJson.ip;
}
